// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_jVR","cls2":"CiterightInline-cls2_HDJ CiterightInline-cls1_jVR"};